<template>
  <div class="app-body">
    <!--START: Title-->
    <div
      class="title-wrapper"
      :class="{ 'show-shadow': showOptions.headerShadow }"
    >
      <div class="title-info">
        <h3 class="title">Connect Shopify</h3>
        <p>Enable order tracking, product recommendations and more</p>
      </div>
      <div class="actions-wrapper">
        <button class="btn btn-small btn-primary" @click="addApp">
          Continue
        </button>
      </div>
    </div>
    <!--END: Title-->

    <!--START: Form-->
    <div class="scroll-body" ref="formBody" @scroll="bodyScroll">
      <div class="notification-alert">
        <unicon name="exclamation-circle"></unicon>
        <span>Instructions to create Shopify API credentials</span>
        <a
          href="https://youtu.be/YLhxIGh2uBY?si=pZS2dURNf0RLY3Af"
          target="_blank"
          >Watch Video</a
        >
      </div>

      <!--START:  Fields Options-->
      <SettingsForm
        v-for="field in fields"
        :key="field._id"
        :fields="field.fields"
        :content="field.content"
        additionalClass="two-column-form"
      ></SettingsForm>
      <!--END:  Fields Options-->
    </div>
    <!--END: Form-->
  </div>
</template>
  
<script>
// Importing components
import SettingsForm from "@/components/form/SettingsForm";

export default {
  name: "AddShopifyForm",
  data() {
    return {
      showOptions: {
        headerShadow: false,
      },
      fields: {
        app: {
          content: {
            title: "Shopify API Credentials",
            description: "Add your Shopify credentials to connect to Macha",
          },
          fields: {
            shopName: {
              type: "text",
              placeholder: "Your shop name",
              required: true,
              hasError: false,
              title: "Shop name*",
              value: "",
            },
            adminApiAccessToken: {
              type: "text",
              placeholder: "Add access token",
              required: true,
              hasError: false,
              title: "Admin API access token*",
              value: "",
            },
            apiKey: {
              type: "text",
              placeholder: "Add the API key",
              required: true,
              hasError: false,
              title: "API key*",
              value: "",
            },
            apiSecretKey: {
              type: "text",
              placeholder: "Add the API secret key",
              required: true,
              hasError: false,
              title: "API secret key*",
              value: "",
            },
          },
        },
      },
    };
  },
  props: {},
  watch: {},
  components: {
    SettingsForm,
  },
  computed: {},
  async created() {},
  mounted() {},
  methods: {
    // Add the site
    addApp() {
      // Check if the form has valid input
      const data = this.fields.app.fields;
      var isFormValid = this.validateForm(data);
      if (isFormValid) {
        const payload = this.constructPayload(data);
        this.$emit("addApp", payload);
      }
    },

    // Construct the payload
    constructPayload(data) {
      const payload = {
        appName: "shopify",
        credentials: this.parseData(data),
      };

      return payload;
    },

    // Event on body scroll
    bodyScroll() {
      const scrollTop = this.$refs.formBody.scrollTop;

      if (scrollTop > 0) this.showOptions.headerShadow = true;
      else this.showOptions.headerShadow = false;
    },
  },
};
</script>
  
<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";
.notification-alert {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: lighten($redColor, 30%);
  border: 1px solid $redColor;
  padding: 0.25rem 0.5rem;
  border-radius: 0.35rem;
  font-size: $smallerFontSize;
  width: fit-content;
  color: darken($redColor, 25%);
  margin: -1rem 0 1rem;

  a {
    display: block;
    margin-left: 0.5rem;
    font-weight: $mediumFontWeight;
    color: darken($redColor, 30%);
    text-decoration: underline;
    margin-bottom: 0;
  }

  /deep/ .unicon {
    svg {
      width: 1rem;
      height: auto;
      fill: darken($redColor, 30%);
      margin-right: 0.5rem;
      transform: translateY(1px);
    }
  }
}
</style>